if (typeof G === 'undefined') G = {};
G.UI = G.UI || {};

(function(){

//

G.UI.ExportsManager = function ExportsManager() {
  this._arrayByName = {};
  this.result = new ExportsManagerResult(this._arrayByName);
};

G.UI.ExportsManager.prototype.exportElement = function exportElement(name, element) {
  if (!this._arrayByName[name]) {
    this._arrayByName[name] = [];
  }
  this._arrayByName[name].push(element);
};

//

function ExportsManagerResult(arrayByName) {
  this._arrayByName = arrayByName;
}

ExportsManagerResult.prototype.getArrayByName = function getArrayByName() {
  return this._arrayByName;
};

ExportsManagerResult.prototype.getAmountOf = function getAmountOf(name) {
  var array = this._arrayByName[name];
  return array ? array.length : 0;
};

 /** @param {boolean|"throw"|"warn"|Function} [optUnavailableAction] = "throw" */
ExportsManagerResult.prototype.getFirst = function getFirst(name, optUnavailableAction) {
  var unavailableAction = defaultValue(optUnavailableAction, 'throw');
  if (this.getAmountOf(name) > 0) {
    return this._arrayByName[name][0];
  } else {
    handleUnavailable(unavailableAction, name);
    return {
      rootElement: null,
      exports: new ExportsManagerResult({})
    };
  }
};

 /** @param {boolean|"throw"|"warn"|Function} [optUnavailableAction] = "warn" */
ExportsManagerResult.prototype.forFirst = function forFirst(name, action, optUnavailableAction) {
  var unavailableAction = defaultValue(optUnavailableAction, 'warn');
  if (this.getAmountOf(name) > 0) {
    var element = this.getFirst(name);
    action(element.rootElement, element.exports);
  } else {
    handleUnavailable(unavailableAction, name);            
  }
};

 /** @param {boolean|"throw"|"warn"|Function} [optUnavailableAction] = "warn" */
ExportsManagerResult.prototype.forEvery = function forEvery(name, action, optUnavailableAction) {
  var unavailableAction = defaultValue(optUnavailableAction, 'warn');
  if (!_forEvery(this._arrayByName, name, action)) {
    handleUnavailable(unavailableAction, name);
  }
};

//

function _forEvery(customArrayByName, name, action) {
  var array = customArrayByName[name];
  if (array && array.length > 0) {
    array.forEach(function(arrayElement, index) {
      action(arrayElement.rootElement, index, arrayElement.exports);
    });
    return true;
  }
  return false;
}

function defaultValue(value, itsDefaultValue) {
  return (value === undefined || value === null) ? itsDefaultValue : value;
}

/** @param {boolean|"throw"|"warn"|Function} [optUnavailableAction] = "throw" */
function handleUnavailable(optUnavailableAction, name) {
  var message = 'Element ' + name + ' not found';
  if (
    optUnavailableAction === undefined ||
    optUnavailableAction === null
  ) {
    throw message;
  }
  if (typeof optUnavailableAction === 'function') {
    optUnavailableAction(name);
  } else {
    if (typeof optUnavailableAction === 'string') {
      if (
        optUnavailableAction.length > 0 &&
        optUnavailableAction[0].toLowerCase() === 'w'
      ) {
        console.warn(message);    
      } else {
        throw message;
      }
    } else {
      if (optUnavailableAction !== false) {
        throw message;
      }
    }
  }
}

}());
